/* eslint-disable no-unused-vars */
import React, { Component } from 'react';
import IconButton from '@material-ui/core/IconButton';
import Info from '@material-ui/icons/Info';
import ReplyIcon from '@material-ui/icons/Reply';
import Typography from '@material-ui/core/Typography';
import Utils from '../../utils/utils';
import ArrowSlider from '../../components/ArrowSlider';
import OIMODAL from '../../components/Modals/OI Modal';
import styles from './OptionsBoardStyles';
import { formatPercentFine } from '../../utils/numberFormatFunc';
import {
  barDataFunc,
  chartDataFunction,
  chartOptionsFunction,
  chartOptionsMobileFunc,
} from './chartConfig';
import VolumeModal from './BasicCallBoard/VolumeModal';
import ModalTable from './BasicCallBoard/Table';
import CallsViewer from './BasicCallBoard/CallsViewer';
let prevIndex
class BasicCallBoard extends Component {
  constructor(props) {
    super(props);
    this.state = {
      showModal: false,
      activeRow: {},
      orderBy: 'asc',
      order: 'asc',
      isOIchecked: false,
      modalRowData: [],
      shouldOpenModal: false,
      showWatchListModal: false,
      checked: [],
      rows: [],
    };
  }
  componentDidUpdate(prev) {
    if (prev.rows !== this.props.rows) {
      this.setRows(this.props.rows, this.props.latestPrice);
    }
    if (prev.rows !== this.state.rows) {
      this.setRows(this.props.rows, this.props.latestPrice);
    }

    if (prev.highestEdge.rowIndex !== this.props.highestEdge.rowIndex) {
      // this.scrollToAny(this.props.highestEdge.rowIndex);
    }
  }

  closeOIModal = () => this.setState({ shouldOpenModal: false });

  toggleModal = (row) => {
    const { ticker, modalDate } = this.props;
    const { showModal } = this.state;

    if (showModal) {
      this.setState({ activeRow: {}, showModal: false });
    } else {
      this.setState({ activeRow: row });
      this.props.fetchOptionsDetail(
        ticker,
        row.expiry,
        row.put_call,
        row.strike,
        modalDate
      );
      this.setState({ showModal: true });
    }
  };

  createReference(data) {
    data.forEach((row) => {
      row.reference = React.createRef();
    });
    return data;
  }
  sortData = (type) => {
    this.setState({ orderBy: type });
    const { orderBy, order } = this.state;
    const isAsc = orderBy === type && order === 'asc';
    this.setState({ order: isAsc ? 'desc' : 'asc' });
  };

  async setRows(data, latestPrice) {
    data = await this.createReference(data);
    this.setState({ rows: data });
    this.scrollToLatestPrice(latestPrice);

    if (typeof this.props.highestEdge !== "undefined" && this.props.highestEdge !== null && typeof this.props.highestEdge.rowIndex !== "undefined" && !isNaN(this.props.highestEdge.rowIndex)) {
      // this.scrollToAny(this.props.highestEdge.rowIndex);
    }
    // if (this.props.highestEdge.rowIndex) {
    //   this.scrollToAny(this.props.highestEdge.rowIndex);
    // }
  }

  async scrollToAny(rowIndex) {

    if (prevIndex == rowIndex) {
      return
    }
    const { rows } = this.state;


    if (rows.length > 0 && rows[rowIndex] && rows[rowIndex].reference.current) {
      const trElement = rows[rowIndex].reference.current;

      // Check if lastTd exists before using scrollIntoView
      const lastTd = trElement.querySelector('td:last-child');
      if (lastTd) {
        try {
          lastTd.scrollIntoView({ behavior: 'smooth', block: 'center' });
          prevIndex = rowIndex
        } catch (error) {
          console.error('Error scrolling to row:', error);
        }
      }
    } else {
      console.warn('Row not found or reference not set for rowIndex:', rowIndex);
    }
  }



  async scrollToLatestPrice(price) {
    if (price) {
      const lowerStrike = price - (price % 7);
      const upperStrike = lowerStrike + 7;
      // setTimeout(() => {
      const index = await this.state.rows.findIndex(
        (row) => row.strike >= lowerStrike && row.strike <= upperStrike
      );
      if (index !== -1) {

        await this.scrollToAny(index);

      }
      // }, 200)
    }
  }

  toggleOICell = (row) =>
    this.setState({
      isOIchecked: true,
      modalRowData: row,
      shouldOpenModal: true,
    });

  render() {
    const {
      highestEdge,
      highestActual,
      answerArrowPos,
      latestPrice,
      currentPriceArrowPos,
      expiration,
      isMobile,
      optionsDetail,
      optionsDetail3,
      ticker,
      width,
      modalDate,
      accessLevel,
      backFromAdvance,
      warnings,
      turnBackOff,
    } = this.props;
    const { rows } = this.state;
    if (backFromAdvance) {
      this.setRows(rows, latestPrice);
      turnBackOff();
    }

    let callBoardWidth = '400px';
    const localOD = optionsDetail.slice().reverse();
    const localOD3 = optionsDetail3;

    const timeline = Utils.generateTimeIntervalsUntil(
      9.5,
      16,
      1,
      localOD,
      'time'
    );

    const timeline2 = Utils.generateBarchatData(9.5, 16, 10, localOD, 'time');
    var lineLabels = [];
    var lineData2 = [];

    for (const [key, value] of Object.entries(timeline)) {
      lineLabels.push(value.time);
      lineData2.push(formatPercentFine(value.ivol));
    }

    var lineData = localOD3.map((opt) => opt.last);
    const barLabel = [];
    const barActualData = [];

    for (const [key, value] of Object.entries(timeline2)) {
      barLabel.push(value.time);
      barActualData.push(value.volume);
    }
    let strikeSliderPosition = 0;
    if (
      rows.length > 0 &&
      currentPriceArrowPos &&
      currentPriceArrowPos.rowPos
    ) {
      const rowPos = currentPriceArrowPos.rowPos;
      if (rows[rowPos] !== undefined && rows[rowPos].hasOwnProperty('strike')) {
        var strikeDiff = 1;
        if (rows[rowPos + 1]) {
          strikeDiff = rows[rowPos + 1].strike - rows[rowPos].strike;
        } else if (rows[rowPos]) {
          strikeDiff = rows[rowPos].strike - rows[rowPos - 1].strike;
        }
        const priceDiff = latestPrice - rows[rowPos].strike;
        strikeSliderPosition = 0.05 + rowPos + priceDiff / strikeDiff;
      }
    }
    const chartData = chartDataFunction(
      lineLabels,
      isMobile,
      ticker,
      lineData,
      lineData2
    );

    const chartOptions = chartOptionsFunction(ticker, lineLabels);
    const chartOptionsMobile = chartOptionsMobileFunc(ticker, lineLabels);
    const barData = barDataFunc(barLabel, barActualData);
    return (
      <div
        style={
          isMobile
            ? { width: '60%' }
            : { width: window.innerWidth > 2200 ? callBoardWidth : '400px' }
        }
      >
        {this.state.shouldOpenModal && (
          <OIMODAL
            accessLevel={accessLevel}
            showModal={this.state.shouldOpenModal}
            ticker={ticker}
            expiration={expiration}
            modalRowData={this.state.modalRowData}
            closeOIModal={this.closeOIModal}
            selectedDate={modalDate}
          />
        )}
        <VolumeModal
          state={this.state}
          sortData={this.sortData}
          chartData={chartData}
          localOD={localOD}
          chartOptionsMobile={chartOptionsMobile}
          chartOptions={chartOptions}
          barData={barData}
          toggleModal={this.toggleModal}
          keyName="Calls"
        />
        <CallsViewer
          backgoSelect={this.props.backgoSelect}
          answerArrowPos={answerArrowPos}
          currentPriceArrowPos={currentPriceArrowPos}
          highestActual={highestActual}
          highestEdge={highestEdge}
          rows={this.state.rows}
          warnings={warnings}
          showAdvancedBoard={this.props.showAdvancedBoard}
          strikeSliderPosition={strikeSliderPosition}
          setWatchListData={this.props.setWatchListData}
          openOICall={this.props.openOICall}
          toggleModal={this.toggleModal}
          toggleOICell={this.toggleOICell}
        />
      </div>
    );
  }
}

export default BasicCallBoard;



// WEBPACK FOOTER //
// ./src/Pages/OptionsBoard/BasicCallBoard.js